export const capitalizeFirstWord = (str: string): string => {
  return str?.charAt(0).toUpperCase() + str?.slice(1)!;
};

/**
 * Normalizes team search for APIs that match case-sensitively: each word is
 * title-cased ("liverpool" → "Liverpool", "MAN UNITED" → "Man United").
 */
export const normalizeTeamSearchQueryForApi = (query: string): string => {
  return query
    .trim()
    .split(/\s+/)
    .map((word) =>
      word.length === 0
        ? ''
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .filter(Boolean)
    .join(' ');
};

export const addOrdinalSuffix = (number: number): string => {
  if (typeof number !== 'number') return '';
  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return `${number}th`;
  }

  switch (lastDigit) {
    case 1:
      return `${number}st`;
    case 2:
      return `${number}nd`;
    case 3:
      return `${number}rd`;
    default:
      return `${number}th`;
  }
};
